import { mediumPasswordRegExp, strongPasswordRegExp } from '../regExp'
import { InputPasswordProps } from '@conexasaude/conexa-hero'

export const checkPasswordStrength = (
  password: string,
): InputPasswordProps['strength'] => {
  if (strongPasswordRegExp.test(password)) {
    return 'strong'
  }

  if (mediumPasswordRegExp.test(password)) {
    return 'medium'
  }

  return 'weak'
}
